import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RouterManagerService } from '../../managers/router-manager.service';
import { RoleUsers } from '../../../model/role-users';
import { StorageService } from '../../managers/storage.service';
import { Config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class RoleUsersService extends Config{


  constructor(private httpClient: HttpClient, private routerManagerService: RouterManagerService,
    private storageService: StorageService) { 
      super();
    }

  public storeRoleUsers(roleUsers: RoleUsers) {
    let url = "role_user_store";

    return this.httpClient.post(this.BASE_URL + url, roleUsers, this.storageService.getHeaders());
    //return this.httpClient.post(t)
  }

  public getRoleUsers(userID: number) {
    let url = "role_user";
    return this.httpClient.post(this.BASE_URL + url, {"userID": userID}, this.storageService.getHeaders());
  }

  public updateRoleUser(roleUsers: RoleUsers) {
    var url = "role_user_update";

    return this.httpClient.post(this.BASE_URL + url, roleUsers, this.storageService.getHeaders());
  }

}
